<template>
  <div>
    <headline code="titre-soumission"></headline>
    <ressource code="texte-soumission" hide-if-empty></ressource>
    <panier class="mb-6" v-if="avecPanier"></panier>

    <div class="mt-6">
      <v-btn x-large dark color="primary" @click="submit">Soumettre</v-btn>
    </div>
    <ophq-alert type="error" class="mt-6" code="formulaire-incomplet" max-width="700" v-show="showAlert"></ophq-alert>
    <ophq-alert type="error" class="mt-6" code="validation_backend_failed" max-width="700" v-show="validationBackendFailed"></ophq-alert>
    <v-alert type="error" text class="mt-6" max-width="700" v-show="soumissionEchouee">
      <div>{{ $t("formulaires.soumissionEchouee") }}</div>
      <div v-if="messageSoumissionEchouee" class="mt-2">{{ messageSoumissionEchouee }}</div>
    </v-alert>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import Panier from "@/components/form_parts/Panier"
export default {
  props: {
    showAlert: {
      type: Boolean,
      default: false
    },
    validationBackendFailed: {
      type: Boolean,
      default: false
    },
    soumissionEchouee: {
      type: Boolean,
      default: false
    },
    messageSoumissionEchouee: {
      type: String,
      default: null
    },
    avecPanier: {
      type: Boolean,
      default: false
    }
  },
  components: { Panier },

  computed: {
    ...mapGetters(["sas"])
  },

  methods: {
    submit() {
      this.$emit("submit")
    }
  }
}
</script>

<style></style>
